"use client"
import React, { useState, useEffect } from 'react'
import '../auth.css'
import logo from "/public/logo.svg"
import {
  Box
} from "@mui/material";
import EmailSent from './EmailSent';
import EnterNewPassword from './EnterNewPassword';

import Footer from './Footer'
import ResetPassword from './ResetPassword';

const ForgotPassword = () => {

  const [resetPassword, setResetPassword] = useState(false)
  const [enterNewPassword, setEnterNewPassword] = useState(false)
  const [successMail, setSuccessMail] = useState(false);
  const [userId, setUserId] = useState('');

  useEffect(() => {
    console.log(resetPassword, enterNewPassword);
    
  }, [resetPassword, enterNewPassword])

  const handleUserId = (e:any) =>{
    setUserId(e)
  }
  return (
    <Box className='auth-banner'  sx={{ position:'relative' }}>
      <Box className='login-box'>

        <Box
          sx={{
            textAlign: 'center',
          }}
        >
          <img
            src={"logo.svg"}
            alt="logo"
            style={{ cursor: "pointer", marginBottom: '24px' }}
          />

          {
            resetPassword === false && enterNewPassword === false ? (
             <ResetPassword setResetPassword={setResetPassword} resetPassword={resetPassword} setSuccessMail={setSuccessMail} setUserId={handleUserId} />
            ) : (
              resetPassword === true && enterNewPassword === false ? (
                <EmailSent setEnterNewPassword={setEnterNewPassword} enterNewPassword={enterNewPassword} successMail={successMail} resetUserId={userId} />
              ) : (
                <EnterNewPassword />
              )
            )
          }

          <Footer />
        </Box>
      </Box>
    </Box >
  )
}

export default ForgotPassword